import { Typography } from '@mui/material';
import { Colors } from '../../styles/theme';
import { FC } from 'react';

interface SectionTitleProps {
  title: string;
  subtitle: string;
  align?: 'left' | 'center' | 'right';
}

const SectionTitle: FC<SectionTitleProps> = ({
  title,
  subtitle,
  align = 'center',
}) => {
  return (
    <Typography
      variant="h3"
      sx={{
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: { xs: '32px', md: '60px' },
        lineHeight: '130%',
        letterSpacing: '-5%',
        textAlign: align,
      }}
    >
      <span style={{ color: Colors.blackAlpha30 }}>{title}</span>
      <br />
      {subtitle.split('\n').map((line, idx) => (
        <span key={idx} style={{ color: Colors.black }}>
          {line}
          {idx < subtitle.split('\n').length - 1 && <br />}
        </span>
      ))}
    </Typography>
  );
};

export default SectionTitle;
